import { useContext } from "react";
import debugContext from "@lib/contexts/debug";
import DebugInfo from "@components/Debug/Info";

export default function DebugLocationPopup({
  className = "",
  label,
  components,
}: {
  className?: string;
  label: string;
  components?: be.FieldValue[];
}) {
  const { debugMode } = useContext(debugContext);

  if (!debugMode || !components) return null;

  const fareComponents = {};
  components.forEach((component) => {
    fareComponents[component.field] = parseFloat(component.value);
  });

  return (
    <DebugInfo
      className={className}
      dialogContent={<pre>{JSON.stringify(fareComponents, null, 2)}</pre>}
    >
      {label}
    </DebugInfo>
  );
}
